module.exports = __webpack_public_path__ + "static/media/gota.3cec8ffb.png";